/**
 * Generated by orval v6.11.1 🍺
 * Do not edit manually.
 * Primer backend API
 * A backend service implementing a pedagogic functional programming language.
 * OpenAPI spec version: 0.7
 */

export type Level = typeof Level[keyof typeof Level];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Level = {
  Beginner: 'Beginner',
  Intermediate: 'Intermediate',
  Expert: 'Expert',
} as const;
